"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addAnnualCommonWidgets = void 0;
var GdprBanner_1 = require("./GdprBanner");
var FalconNavigatorHeaderWidget_1 = require("./FalconNavigatorHeaderWidget");
var NotificationModalWidget_1 = require("./NotificationModalWidget");
var UniqueSellingPointWidget_1 = require("./UniqueSellingPointWidget");
var MTASummaryWidget_1 = require("./MTASummaryWidget");
var AggRefAndQuoteNumberOutputWidget_1 = require("./AggRefAndQuoteNumberOutputWidget");
var SupportPortalPaymentChoiceWordingWidget_1 = require("./SupportPortalPaymentChoiceWordingWidget");
var SupportPortalAnnualPriceWidget_1 = require("./SupportPortalAnnualPriceWidget");
var LvToAllianzUKTransferBanner_1 = require("./LvToAllianzUKTransferBanner");
var SupportPortalMarketingPreferencesOutputWidget_1 = require("./SupportPortalMarketingPreferencesOutputWidget");
var DrivingLicencePriceUpdateBanner_1 = require("./DrivingLicencePriceUpdateBanner");
var RenewalLastYearPriceWidget_1 = require("./RenewalLastYearPriceWidget");
var addAnnualCommonWidgets = function (extensions) {
    extensions.journeyComponents.addQuestionComponent({
        id: "gdprBanner",
        component: GdprBanner_1.GdprBanner
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "falconNavigatorHeader",
        component: FalconNavigatorHeaderWidget_1.FalconNavigatorHeaderWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "notificationModal",
        component: NotificationModalWidget_1.NotificationModalWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "uniqueSellingPointWidget",
        component: UniqueSellingPointWidget_1.UniqueSellingPointWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "MTASummaryWidget",
        component: MTASummaryWidget_1.MTASummaryWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "aggRefAndQuoteNumberOutputWidget",
        component: AggRefAndQuoteNumberOutputWidget_1.AggRefAndQuoteNumberOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "supportPortalPaymentChoiceWording",
        component: SupportPortalPaymentChoiceWordingWidget_1.SupportPortalPaymentChoiceWordingWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "supportPortalAnnualPrice",
        component: SupportPortalAnnualPriceWidget_1.SupportPortalAnnualPriceWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "lvToAllianzUKTransferBanner",
        component: LvToAllianzUKTransferBanner_1.LvToAllianzUKTransferBanner
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "supportPortalMarketingPreferencesOutput",
        component: SupportPortalMarketingPreferencesOutputWidget_1.SupportPortalMarketingPreferencesOutputWidget
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "drivingLicencePriceUpdateBanner",
        component: DrivingLicencePriceUpdateBanner_1.DrivingLicencePriceUpdateBanner
    });
    extensions.journeyComponents.addQuestionComponent({
        id: "renewalLastYearPrice",
        component: RenewalLastYearPriceWidget_1.RenewalLastYearPriceWidget
    });
};
exports.addAnnualCommonWidgets = addAnnualCommonWidgets;
//# sourceMappingURL=index.js.map